import React, { useEffect, useState } from 'react'
import { authHeader } from '../../utils'
import axios from 'axios'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../store/types'
import InlinePreloader from './InlinePreloader'

const StudentSubjectCard = ({subject, student, additionalInfo, hideTeacher = false}) => {
    const studentClass = student.class.class._id || undefined
    const indexOfStudentClass = subject.classes.findIndex(subjectClass => subjectClass.class._id === studentClass)

    const [subjectAssessments, setSubjectAssessments] = useState(['0', '0', '0', '0', '0'])
    const [loading, setLoading] = useState(true)

    const dispatch = useDispatch()

    useEffect(() => {
      
        const fetchAssessmentScores = async () => {
            try {
            const headers = authHeader()

            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/assessment-records/student/${student._id}?subject=${subject._id}&page=1&perPage=5`, { headers })            

            // Transform assessment scores to array of percentage strings
            const scores = response.data.data.assessmentRecords.map(assessment => assessment.percentageScore.toString())
            // Reverse so most recent scores are at the end
            scores.reverse()
            // Pad with '0' at the beginning to ensure always 5 values
            while (scores.length < 5) scores.unshift('0')
            
            setSubjectAssessments(scores.slice(-5))
            setLoading(false)
            } catch (error) {
                console.log(error)
                dispatch({
                    type: ERROR,
                    error
                })
                setLoading(false)
            }
        }

        fetchAssessmentScores()

        return () => {
            
        }
    }, [dispatch, student._id, subject._id])
    

    return (
        <div className='w-full rounded bg-gray-50 p-[20px]'>
            <p className='font-space-grotesk font-[550]'>{subject.name} {subject.shortName && <span className='text-sm text-gray-600'>({subject.shortName})</span>}</p>
            {/* <p className='text-sm text-gray-700 mt-[5px]'>{subject.description}</p> */}
            
            <div className='flex flex-row-reverse items-center justify-between gap-x-[10px]'>
                <div>
                {!hideTeacher && 
                    <>
                    <p className='text-xs text-gray-700 mt-[10px] mb-[5px]'>Taught by:</p>
                    {subject.classes[indexOfStudentClass]?.teachers.map((teacher, teacherIndex) => (
                        <p key={teacherIndex} className='text-sm font-[500] text-gray-700'>{teacher.fullName}</p>
                    ))}
                    </>
                }
                </div>

                <div className='w-[70px]'>
                    <p className='text-xs text-gray-500 mt-[10px] mb-[10px]'>Performance</p>
                    {loading ?
                        <div className="w-6">
                            <InlinePreloader />
                        </div>
                    :
                    // Bar chart (commented out)
                    // <div className='flex items-end justify-between w-full gap-x-[10px] h-[25px]'>
                    //     {subjectAssessments.map((score, scoreIndex) => (
                    //         <div key={scoreIndex} className='h-[25px] bg-purple-100 w-[7px] flex items-end'>
                    //             <div style={{height: score+'%'}} className='bg-purple-600 w-[7px]' />
                    //         </div>
                    //     ))}
                    // </div>
                    
                    // Sparkline
                    <svg width="70" height="25" className="overflow-visible">
                        <polyline
                            fill="none"
                            stroke="#7c3aed"
                            strokeWidth="2"
                            points={subjectAssessments.map((score, index) => {
                                const x = (index / (subjectAssessments.length - 1)) * 70
                                const y = 25 - (parseFloat(score) / 100) * 25
                                return `${x},${y}`
                            }).join(' ')}
                        />
                        {subjectAssessments.map((score, index) => {
                            const x = (index / (subjectAssessments.length - 1)) * 70
                            const y = 25 - (parseFloat(score) / 100) * 25
                            return <circle key={index} cx={x} cy={y} r="2" fill="#7c3aed" />
                        })}
                    </svg>
                    }

                </div>
            </div>

            {additionalInfo && 
                <div className='mt-[10px] pt-[10px] border-t border-gray-300'>
                    {additionalInfo}
                </div>
            }

        </div>
    )
}

export default StudentSubjectCard